<footer class="page__footer">
  <div class="runway runway--grey-white runway--centered runway--border-top footer-logo">
    <a href="" class="logo" title="Gå til forsiden">
      <img src="assets/img/ok-logo.svg" alt="OK a.m.b.a." />
    </a>
  </div>
</footer>
